// ═══════════════════════════════════════════════════════════════════════════
// FARM-BOOKING - PROTECTION ROUTES ADMIN (VERSION AUTONOME)
// ═══════════════════════════════════════════════════════════════════════════
// Vérifie que l'utilisateur est un admin connecté (superviseur)
// VERSION SANS useAuth - Lecture directe localStorage
// 73+ Papy - Janvier 2026
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function AdminProtectedRoute({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      try {
        // Lecture directe depuis localStorage
        const storedToken = localStorage.getItem('farm_admin_token');
        const storedUser = localStorage.getItem('farm_admin_user');
        
        if (storedToken && storedUser) {
          const user = JSON.parse(storedUser);
          
          // Vérifier le rôle (superviseur ou admin acceptés)
          if (user.role === 'superviseur' || user.role === 'admin' || !user.role) {
            setIsAuthenticated(true);
          } else {
            console.log('🚫 Rôle insuffisant:', user.role);
            setIsAuthenticated(false);
          }
        } else {
          console.log('🚫 Pas de token ou user admin dans localStorage');
          setIsAuthenticated(false);
        }
      } catch (err) {
        console.error('❌ Erreur vérification auth:', err);
        setIsAuthenticated(false);
      }
      
      setIsLoading(false);
    };

    // Vérifier immédiatement
    checkAuth();
  }, []);

  // ⏳ Loader pendant la vérification
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-green-500 border-t-transparent mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification des accès...</p>
        </div>
      </div>
    );
  }

  // 🚫 Pas authentifié → Login admin
  if (!isAuthenticated) {
    return <Navigate to="/gestion" replace />;
  }

  // ✅ Authentifié → Afficher le contenu
  return children;
}